import { PageId } from 'constants/pages'
import { isEmpty } from 'lodash'
import { TStep } from 'nove8/types'
import { StatesConfig } from 'xstate'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandGlobalStore, useZustandStore } from 'zustandGlobalStore'

const getHasAnswers = () =>
  !isEmpty(
    useZustandSessionStore.getState().userAnswers ||
      useZustandGlobalStore.getState().lead?.quizzes ||
      null,
  )

const shouldRedirectUser = () => {
  const userSubscriptions = useZustandGlobalStore.getState().lead?.subscriptions
  const hasRedirectFlow = userSubscriptions?.find(
    (subscription) =>
      subscription.productName === 'vc' &&
      !['created', 'cancelled'].includes(subscription.status),
  )
  return hasRedirectFlow
}

export const getXStateConfigWoofzVc6 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    // Pay attention to the order of the conditions!
    always: [
      // Cover case when page was reloaded or connection was lost
      // during the purchase polling
      {
        cond: (): boolean => {
          const userHasChat = useZustandStore.getState().userHasChat
          return !!shouldRedirectUser() && userHasChat
        },
        target: PageId.ALL_SET_VC6,
      },
      {
        cond: (): boolean => {
          const userHasChat = useZustandStore.getState().userHasChat
          return !!shouldRedirectUser() && !userHasChat
        },
        target: PageId.CALENDLY_VC6,
      },
      {
        cond: (): boolean => !!useZustandGlobalLocalStore.getState().purchaseId,
        target:
          useZustandGlobalLocalStore.getState().purchasePageId ||
          pages[0].pageId,
      },
      {
        cond: (): boolean => {
          const hasAnswers = getHasAnswers()
          return hasAnswers
        },
        target:
          pages.find((dynamicPage) => {
            const pageIdFromUrl =
              window.location.pathname.split('/').pop() || ''
            return pageIdFromUrl === dynamicPage.pageId
          })?.pageId || pages[0].pageId,
      },
      {
        target: pages[0].pageId, // Always transition to first page as fallback
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          ...(page.pageId === PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6 && {
            NEXT_FLOW_STEP: {
              target: PageId.CALENDLY_VC6,
            },
          }),
          ...(page.pageId === PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6 && {
            NEXT_FLOW_STEP: {
              target: PageId.CALENDLY_VC6,
            },
            PREVIOUS_FLOW_STEP: {
              target: PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6,
            },
          }),
          ...(page.pageId === PageId.OUR_MISSION_VC6 && {
            NEXT_FLOW_STEP: {
              target: PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6,
            },
          }),
        },
      },
    }),
    {},
  ),
  calendly_vc6: {
    on: {
      NEXT_FLOW_STEP: 'all_set_vc6',
    },
  },
  all_set_vc6: {
    type: 'final',
  },
})
